export default __webpack_public_path__ + "static/media/freelancing.4f583e37.svg";